<template>
  <div class="alarm-card" :class="{'card-pending': status === '0','card-processed': status === '1','card-urgent': isUrgent}">

    <div class="card-header">
      <div class="alarm-name-wrap">
        <van-icon color="#FF4D4F" :name="alarmIcon" size="20" />
        <span class="alarm-name">{{ item.alarmName || '-' }}</span>
      </div>

      <span class="status-tag" :class="status === '0' ? 'tag-pending' : 'tag-processed'">
        {{ status === '0' ? item.alarmStatus === '0' ? '报警中' : '待处理' : '已处理' }}
      </span>
    </div>

    <div class="card-body">
      <div class="info-row">
        <div class="info-cell">
          <div class="info-label">触发值范围</div>
          <div class="info-value value-text">{{ alarmValueText }}</div>
        </div>
        <div class="info-cell">
          <div class="info-label">达标值范围</div>
          <div class="info-value range-text">{{ factorRangeText }}</div>
        </div>
      </div>

      <div class="info-row">
        <div class="info-cell full-width">
          <div class="info-label">异常时间段</div>
          <div class="info-value time-text">{{ timeRangeText }}</div>
        </div>
      </div>

      <template v-if="status === '1'">
        <div class="info-row">
          <div class="info-cell">
            <div class="info-label">处理人</div>
            <div class="info-value handler-text">
              <van-icon name="manager-o" size="14" />
              {{ item.userName || '-' }}
            </div>
          </div>
          <div class="info-cell">
            <div class="info-label">处理时间</div>
            <div class="info-value">{{ item.updateTime || '-' }}</div>
          </div>
        </div>

        <div class="desc-box">
          <div class="desc-title">
            <van-icon name="description" size="14" />
            处理描述
          </div>
          <div class="desc-content">{{ item.measures || '暂无描述' }}</div>
        </div>
      </template>
    </div>

    <div class="card-footer">
      <span class="tenant-tag">
        <van-icon name="location-o" size="12" />
        {{ item.tenantName || '-' }}
      </span>
      <van-button v-if="status === '0'" type="primary" size="small" class="action-btn" @click="$emit('open-handle', item)">处理</van-button>
      <van-button v-else size="small" class="action-btn detail-btn" @click="$emit('show-detail', item)">详情</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlarmCard',
  props: {
    item: { type: Object, required: true },
    status: { type: String, default: '0' }
  },
  computed: {
    alarmIcon() {
      const map = { '0': 'warning', '1': 'warning-o'};
      return map[this.status] || 'warning';
    },
    isUrgent() {
      return this.item.alarmStatus === '0';
    },
    alarmValueText() {
      const item = this.item;
      const isEmpty = v => v === null || v === undefined || v === '';
      if (!isEmpty(item.minValue) && !isEmpty(item.maxValue)) {
        return item.minValue + ' ~ ' + item.maxValue + (item.factorUnit || '');
      }
      return '-';
    },
    factorRangeText() {
      const item = this.item;
      const isEmpty = v => v === null || v === undefined || v === '';
      if (isEmpty(item.rangeValue)) {
        return '-';
      }
      try {
        const parsed = JSON.parse(item.rangeValue);
        if (Array.isArray(parsed) && parsed.length >= 2) {
          return parsed[0] + ' ~ ' + parsed[1] + (item.factorUnit || '');
        }
      } catch (e) {}
      return item.rangeValue;
    },
    timeRangeText() {
      const item = this.item;
      if (item.alarmStartTime && item.alarmEndTime) {
        return item.alarmStartTime + ' ~ ' + item.alarmEndTime;
      }
      return '-';
    },
  },
};
</script>

<style lang="less" scoped>
.alarm-card {
  background: #fff;
  border-radius: 14px;
  padding: 16px;
  margin-bottom: 12px;
  border: 1px solid #EBEEF5;
  transition: all 0.2s;

  &.card-pending {
    border-top: 3px solid #FF4D4F;
  }

  &.card-processed {
    border-top: 3px solid #52C41A;
  }

  &.card-urgent {
    animation: urgentBlink 2s infinite;
  }
}

@keyframes urgentBlink {
  0%, 100% { box-shadow: 0 0 0 0 rgba(255, 77, 79, 0); }
  50% { box-shadow: 0 0 0 6px rgba(255, 77, 79, 0.15); }
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.alarm-name-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.alarm-name {
  font-size: 30px;
  font-weight: 600;
  color: #1a365d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-tag {
  font-size: 22px;
  padding: 4px 12px;
  border-radius: 14px;
  font-weight: 600;
  flex-shrink: 0;

  &.tag-pending {
    background: #FFECEB;
    color: #FF4D4F;
  }

  &.tag-processed {
    background: #E8F7EA;
    color: #52C41A;
  }
}

.card-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-row {
  display: flex;
  gap: 16px;
}

.info-cell {
  flex: 1;
  min-width: 0;

  &.full-width {
    flex: 1 0 100%;
  }
}

.info-label {
  font-size: 22px;
  color: #909399;
  margin-bottom: 4px;
}

.info-value {
  font-size: 26px;
  color: #303133;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .van-icon {
    color: #1B75F6;
    flex-shrink: 0;
  }
}

.value-text {
  color: #FF4D4F;
  font-weight: 600;
}

.time-text {
  font-size: 24px;
  color: #606266;
}

.range-text {
  font-size: 24px;
  color: #45a317;
}

.handler-text {
  color: #1B75F6;
}

.desc-box {
  margin-top: 4px;
  background: #F8FAFC;
  border-radius: 10px;
  padding: 12px 14px;
}

.desc-title {
  font-size: 24px;
  color: #64748B;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  font-weight: 500;

  .van-icon {
    color: #1B75F6;
  }
}

.desc-content {
  font-size: 26px;
  color: #303133;
  line-height: 1.5;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px dashed #EBEEF5;
}

.tenant-tag {
  font-size: 22px;
  color: #64748B;
  display: flex;
  align-items: center;
  gap: 4px;

  .van-icon {
    color: #4A90E2;
  }
}

.action-btn {
  font-size: 24px;
  border-radius: 20px;
  padding: 0 28px;
  height: 52px;
  line-height: 52px;
  background: linear-gradient(135deg, #1B75F6 0%, #4A90E2 100%);
  border: none;

  &.detail-btn {
    background: #fff;
    color: #1B75F6;
    border: 1px solid #1B75F6;
  }
}
</style>
